import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import ScannerView from './scanner-view.vue';
import { ref } from 'vue';

interface IEmits {
  (event: 'change', data: string): void;
}


export default /*#__PURE__*/_defineComponent({
  emits: ["change"],
  setup(__props, { emit: emits }: { emit: ({
  (event: 'change', data: string): void;
}), expose: any, slots: any, attrs: any }) {


const renderVideo = ref(false);

function handleResult(data: string) {
  emits('change', data);
  renderVideo.value = false;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "trigger",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (renderVideo.value = true))
    }, [
      _renderSlot(_ctx.$slots, "default")
    ]),
    (renderVideo.value)
      ? (_openBlock(), _createBlock(ScannerView, {
          key: 0,
          onClose: _cache[1] || (_cache[1] = ($event: any) => (renderVideo.value = false)),
          onResult: handleResult
        }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})